/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ChangeDueDateBulkRequest
 */
export interface ChangeDueDateBulkRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof ChangeDueDateBulkRequest
   */
  customerInvoiceIds: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ChangeDueDateBulkRequest
   */
  newDueDate: string;
}

/**
 * Check if a given object implements the ChangeDueDateBulkRequest interface.
 */
export function instanceOfChangeDueDateBulkRequest(
  value: object,
): value is ChangeDueDateBulkRequest {
  if (
    !("customerInvoiceIds" in value) ||
    value["customerInvoiceIds"] === undefined
  )
    return false;
  if (!("newDueDate" in value) || value["newDueDate"] === undefined)
    return false;
  return true;
}

export function ChangeDueDateBulkRequestFromJSON(
  json: any,
): ChangeDueDateBulkRequest {
  return ChangeDueDateBulkRequestFromJSONTyped(json, false);
}

export function ChangeDueDateBulkRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ChangeDueDateBulkRequest {
  if (json == null) {
    return json;
  }
  return {
    customerInvoiceIds: json["customerInvoiceIds"],
    newDueDate: json["newDueDate"],
  };
}

export function ChangeDueDateBulkRequestToJSON(
  json: any,
): ChangeDueDateBulkRequest {
  return ChangeDueDateBulkRequestToJSONTyped(json, false);
}

export function ChangeDueDateBulkRequestToJSONTyped(
  value?: ChangeDueDateBulkRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    customerInvoiceIds: value["customerInvoiceIds"],
    newDueDate: value["newDueDate"],
  };
}
